import { render, staticRenderFns } from "./WelcomeLayout.vue?vue&type=template&id=a522dc04&"
import script from "./WelcomeLayout.vue?vue&type=script&lang=js&"
export * from "./WelcomeLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports